//This feature is used to manage jobsites. It allows users to retrieve and toggle the status of jobsites. 
//It is for users of type business.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import foremanActionsService from "./foremanActionsService";

const initialState = {
    selectedTicketWorkers: [],
    isError: null,
    isSuccess: null,
    isLoading: null,
    message: null,
}

//send invitation to a new worker to join the organization
export const sendTicketList = createAsyncThunk('ticketWorkers/sendList', 
    async (inviteeData, thunkAPI) => {
        //InviteeData contains the phone number , the name and the lastName of the worker to be invited. 
        try {
            const token = thunkAPI.getState().auth.user.token;
            const response = await foremanActionsService.sendInvitation(token, inviteeData);

            return response;
        } catch (error) {
            const message = 
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);








export const ticketWorkersSlice = createSlice({
    name:'ticketWorkers',
    initialState,
    reducers:{
        resetTicketList: (state) => initialState,
        
      
    },
    extraReducers: (builder) =>{
        builder 
        .addCase(sendTicketList.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(sendTicketList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.selectedTicketWorkers = action.payload;
        })
        .addCase(sendTicketList.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.message = action.payload;
        });
    }
});
export const { resetTicketList } = ticketWorkersSlice.actions;
export default ticketWorkersSlice.reducer